const KEY = "tfj-troll-sounds";
const FILES = {
  giggle: ["giggle-1", "giggle-2", "giggle-3", "giggle-4", "giggle-5"],
  giant: ["grumble-1", "grumble-2"],
  golden: ["golden"],
};
const listeners = new Set();
let unlocked = false;

// Browsers only allow sound after the visitor has clicked, tapped or pressed a key once.
["pointerdown", "keydown", "touchstart"].forEach((e) =>
  window.addEventListener(e, () => { unlocked = true; }, { once: true, capture: true, passive: true }),
);

export const isMuted = () => localStorage.getItem(KEY) === "off";

export const setMuted = (muted) => {
  localStorage.setItem(KEY, muted ? "off" : "on");
  listeners.forEach((fn) => fn(muted));
};

export const onMutedChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const playTrollSound = (kind) => {
  if (isMuted() || !unlocked) return false;
  const list = FILES[kind];
  const audio = new Audio(`/sounds/${list[Math.floor(Math.random() * list.length)]}.mp3`);
  audio.volume = kind === "giant" ? 0.5 : 0.4;
  audio.play().catch(() => {});
  window.__tfjLastSound = audio.src;
  return true;
};
